import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ComponentsModule } from './components/components.module';
import { InvoicesEffects } from './store/effects/invoices.effects';
import { InvoicesFacade } from './store/facades/invoices.facade';
import { PatientsFacade } from './store/facades/patients.facade';
import { reducers } from './store/reducers';
import { PATIENT_MODULE_KEY } from './store/reducers/states';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    StoreModule.forFeature(PATIENT_MODULE_KEY, reducers),
    EffectsModule.forFeature([InvoicesEffects]),
  ],
  declarations: [],
  exports: [ComponentsModule],
  providers: [PatientsFacade, InvoicesFacade],
})
export class NgPatientModule {}
